export const agent = {
  yqmh: "邀请盲盒",
  yqzmh: "邀请赚盲盒",
  bfbkj: "100%开奖",
  yqpy: "邀请朋友",
  pywczcrw: "朋友注册并完成任务",
  hdcmhcs: "获得抽盲盒次数",
  jllb: "奖励列表",
  mhjlbk: "盲盒奖励可能包括：{text}具体金额根据实际获得奖励为准！",
  kkcs: "可开{value}次",
  mhmx: "盲盒明细",
  jpmx: "奖品明细",
  hdmhs: "获得盲盒数",
  hyjd: "好友进度",
  jplx: "奖品类型",
  dbmc: "代币名称",
  ypf: "已派发",
  wpf: "未派发",
  lq: "领取",
  zblw: "周边礼物",
  gxczmh: "恭喜抽中{amount},邀请新人好友,完成任务,获取盲盒",
  lxkflq: "周边礼品奖励请联系客服获取",
  shdz: "收货地址",
  rwmc: "任务名称",
  wczt: "完成状态",
  hdmhsl: "获得盲盒数量",
  zblqdz: "周边领取地址",
  shr: "收货人",
  dh: "电话",
  xxdz: "详细地址",
  yqmhhdgz: "邀请盲盒活动规则",
  yqyl: "一、什么是Biking邀请有礼？",
  yhhkxt: "Biking邀请有礼是Biking用户回馈系统，旨在回馈所有认同Biking、并邀请好友加入Biking的忠实用户。",
  yqhyhdfhjl: "Biking邀请有礼简单易用，用户只需邀请好友，即可获得丰厚奖励。",
  cyhdhqjl: "二、参与活动完成任务能获得什么奖励？",
  hywcrwhdjl: "邀请人邀请好友，好友完成对应任务，邀请人和受邀人都可获得盲盒并开盲盒获得奖励。",
  mhhdgz: "三、盲盒获得规则",
  syrwczc: "1.受邀人完成注册和实名——受邀人获得1次开启机会",
  syrcz: "2.受邀人充值≥100USDT——邀请人和受邀人各获得1次开启机会",
  syrcssxf: "3.受邀人合约手续费产生≥30USDT——邀请人和受邀人各获得2次开启机会",
  qqjyl: "4.期权交易量≥200USDT——邀请人和受邀人各获得2次开启机会",
  yxjyl: "5.Gamefi交易量≥200USDT且订单赔率不低于1.2倍，低于1.2倍赔率订单不统计——邀请人和受邀人各获得2次开启机会",
  xhmrjyl: "6.现货买入交易量≥500USTD——邀请人和受邀人各获得1次开启机会",
  rwqbwc: "每次邀请任务全部完成邀请人最多可以获得8个开启盲盒机会，受邀人都达成最多可以获得9个开启盲盒机会。邀请多人，获得盲盒机会按规则累计增加。",
  qtsm: "四、其他说明",
  mhffsj: "1.盲盒发放时间--后台监测任务10min刷新一次",
  jlffsj: "2.奖励发放时间--后台人工每日中午12点派发一次",
  syyhjkcj: "3.所有用户均可参加，和其他活动不冲突",
  mhcjs: "4.盲盒抽奖次数每月1号清零",
  yqmts: "仅邀请用户成为下级，下级交易为您产生手续费返佣",
  fym: "返佣码",
  fymts: "邀请并直接给下级用户开通不高于自身的返佣比例，下级交易按比例分配手续费返佣",
  szfym: "设置返佣码",
  xzfym: "新增返佣码",
  lj: "链接",
  fybl: "返佣比例",
  yyqhys: "已邀请好友数",
  sykcjs: "剩余可创建",
  tjlx: "推荐类型",
  bwjs: "5.若发现任何个人及团队存在套刷盲盒福利情况，币王保留扣除及取消账户福利资格权益。所有参与此福利用户视为接受官方福利条款，币王交易所保留最终解释权。",
  swmr: "设为默认",
  cffym: "返佣码重复，请输入正确的返佣码",
  qxtjfym: "请先添加返佣码",
  xywdbl: "10 <= 我的返佣比例",
  qsrdybl: "请输入对应比例",
  qsrzqsl: "请输入正确数值",
  qsrbz: "请输入备注",
  bnbhzf: "不能包含特殊字符或表情",
  pfjj: "派发被拒绝",
  pfsb: "奖励派发失败",
  lxkf: "详情请联系客服",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/agent/zh.js